
import { Vue } from 'vue-class-component';

export default class NotFound extends Vue {

}

